import React from 'react';
import { FaEye, FaIntercom, FaPaperPlane, FaRadiationAlt } from 'react-icons/fa';
import CopyToClipboard from '../../../../../core/components/CopyToClipboard';
import { urlWebsite } from '../../../../../../../config';
import { useSocket } from '../../../../../../../hooks/Socket';
import { useModal } from '../../../../../../../hooks/Modal';
import Review from '../../../modules/Review';
import api from '../../../../../../../services/api';
import { useToast } from '../../../../../../../hooks/Toast';

interface ICreateModule {
  lineData: Record<string, any>;
}

export default function ReviewModule({
  lineData,
}: ICreateModule): JSX.Element {

  const { addToast } = useToast();

  const openReview = async (line) => {

    const submission = await api.post(`/send-paper-to-orientator/${line?._id}`);
    addToast({ title: 'Enviado com sucesso', type: 'success' });
  }


  const moduleCreate = (): JSX.Element => {

    return <div onClick={() => openReview(lineData)} style={{ cursor: 'pointer', width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', border: '1px solid #333', margin: '5px' }}>
      <FaPaperPlane title='Enviar para aprovação do orientador' className="hover" style={{ cursor: 'pointer' }} size={20} /></div>;
  }



  return moduleCreate();
}
